/**
 * defa.views.ZoneView
 * A module-view for a Zone model.
 * @version 1.2.0
 */

import View          from 'scripts/poppet/view';
import template      from 'templates/zoneViewSimple.jst.html';
import { Vue }       from 'vue/defavue';
import { T }         from 'defa-object';


// !TODO: When we've externalized the url's, consider changing the nav-events on onClick open.
// think about this in tandem with view-control-settings-view.js as well.

const selectors = {
	buttonOpen: '[data-click=zone-open]',
	inputStrip: '[data-component=zone-radio-strip]',
};

const ZoneSimpleView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template  : template,
	className : 'simpleZone control-module card',
	noAnimate : true,  // views within control modules probably should animate themselves (xzibit-style)
	ui: {
		open: selectors.buttonOpen,
	},
	
	events: {
		'click @ui.open': 'onClickOpen',
	},

	
	templateContext: function(){
		return {
			name               : this.options.settingsHome.get('zone'+this.model.get('zoneNumber')).zoneAlias ||T.tc('ZoneView', 'Zone') + ' ' + this.model.get('zoneNumber'),
			cid                : this.cid + this.model.get('id'),
			switchId           : 'onOffswitch' + this.cid,
		}
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	//
	
	
	/**
	 * Triggers when DOM has finished painting the element.
	 * @void
	 */
	onDomRefresh: function () {
		this.attachSwitch();
	},
	
	/**
	 * Triggers when the zone is clicked.
	 * @void
	 */
	onClickOpen: function ( event ) {
		event.preventDefault();
		this.trigger( 'nav', 'unit:control:zone', [ this.model.get( 'unitId' ), this.model.get('zoneNumber'), ] );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Saves the OnOff attribute to backend
	 * @void
	 * !TODO implement this method in ControlView Poppet view
	 */
	saveModel: function (model, attrs) {
		let self = this;
		self.busy();
		try {
			self.model.getModel(model).save( attrs, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( 'onOff Model was saved!' );
					console.log( 'Fetching temperature models!' );
					self.idle();
				},
				error  : function () {
					console.error( 'onOff failed at saving...' );
					self.idle();
				}
			} );
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},
	
	attachSwitch: function(){
		let self   = this;
		new Vue ({
			el: '#' + 'onOffswitch' + self.cid,
			
			bb() {
				return {
					model: self.model.getModel('1'),
					mode: self.model.getModel('5')
				};
			},
			
			data() {
				return {
					onOffValue: 'ON',
					locked  : !self.options.settingsHome.get('zone'+self.model.get('zoneNumber')).enabled,
				}
			},
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName] = 'ON' === newValue;
					self.saveModel('1',  data )
				},
				
				onClickOpenZone: function (event) {
					self.onClickOpen(event)
				}
			},
			
			watch : {
				'model.onOff' : function (newValue){
					this.onOffValue = newValue ? 'ON' : 'OFF';
				}
			},
			
			computed: {
				disableZoneSwitch: function () {
					return null === this.model.onOff || null === this.mode.zoneMode
				},
				modelError: function () {
					return this.model.modelError
				},
				
				attributeError: function () {
					return this.model.onOffError
				},
				
				modeError: function () {
					return null === this.mode.zoneMode ? this.mode.modelError || this.mode.zoneModeError : null;
				},
				zoneMode: function () {
					return this.mode.zoneMode
				},
					/**
					 * Delegates creating the data for the radio strip based on the zone's mode.
					 * !TODO: Move these new strings introduced to the logic files out of the logic and into either templates or assets
					 * (defa.vars), let's keep the app logic free of strings.
					 * @returns {string}
					 */
				options() {
					let ret = '';
					
					switch ( this.mode.zoneMode ) {
						
						case 'thermostat' :
							ret = [
								{ value: 'ON', title: 'Comfort', titleContext: 'ZoneView' },
								{ value: 'OFF', title: 'Saving', titleContext: 'ZoneView' }
							];
							break;
							
						case 'manual' :
							ret = [
								{ value: 'ON', title: 'On', titleContext: 'ZoneView' },
								{ value: 'OFF', title: 'Off', titleContext: 'ZoneView' }
							];
							break;
							
						case 'regulator' :
							ret = [
								{ value: 'ON', title: 'Comfort', titleContext: 'ZoneView' },
								{ value: 'OFF', title: 'Saving', titleContext: 'ZoneView' }
							];
							break;
							
						case 'disabled' :
							ret = false;
							break;
							
						default:
							ret = [
								{ value: 'ON', title: 'On', titleContext: 'ZoneView' },
								{ value: 'OFF', title: 'Off', titleContext: 'ZoneView' }
							];
					}
					
					return ret;
				}
			},
			
			created () {
				this.onOffValue = this.model.onOff ? 'ON' : 'OFF';
			}
		});
		
	},
	
	
} );

export default ZoneSimpleView;
